import hero from '@/assets/hero.png';
import heromb from '@/assets/heromb.png';

export default function HeroSection() {
  const handleScrollToMenu = () => {
    const el = document.getElementById('menu');
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  const handleCall = () => {
    window.location.href = 'tel:07077860873';
  };

  return (
    <section className="relative w-full h-screen h-dvh flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        {/* モバイル用 */}
        <img
          src={heromb}
          alt="リラクゼーションエステ湯の華 - 和の癒し空間"
          className="w-full h-full object-cover object-top md:hidden"
        />
        {/* PC用 */}
        <img
          src={hero}
          alt="リラクゼーションエステ湯の華 - 和の癒し空間"
          className="hidden md:block w-full h-full object-cover object-center"
        />
      </div>

      <div className="relative z-10 w-full max-w-4xl mx-auto px-6 text-center">
        <div className="animate-fade-in">
          <p className="text-foreground-800 text-sm md:text-base tracking-[0.3em] mb-6 font-sans">
            北海道・室蘭 タイ古式リラクゼーションエステ
          </p>
        </div>

        <div className="animate-fade-in" style={{ animationDelay: '0.3s' }}>
          <h1 className="font-heading text-4xl md:text-6xl lg:text-7xl text-foreground-800 mb-4 tracking-wider">
            湯の華
          </h1>
          <p className="font-heading text-xl md:text-2xl text-foreground-800 tracking-[0.15em] mb-2">
            リラクゼーションエステ
          </p>
        </div>

        <div className="animate-fade-in mt-8" style={{ animationDelay: '0.6s' }}>
          <p className="text-foreground-800/80 text-sm md:text-base leading-relaxed max-w-lg mx-auto mb-10">
            タイ古式の伝統技法と、和のくつろぎが溶け合う<br />
            極上のヒーリング空間であなたをお迎えします
          </p>
        </div>

      </div>

      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 z-10 animate-float">
        <div className="flex flex-col items-center gap-2 text-background-200/90">
          <span className="text-xs tracking-widest font-sans">SCROLL</span>
          <i className="ri-arrow-down-s-line text-lg"></i>
        </div>
      </div>
    </section>
  );
}